<template>
  <div class="btn-list aside">
    <div class="rule-btn" @click="handleRuleClick">
      <span>{{ langData.taskRuleBtn }}</span>
    </div>
    <div class="fb-btn" @click="handleFacebookClick"></div>
    <div class="dc-btn" @click="handleDiscordClick"></div>
  </div>
  <div class="rule-btn-mobile" @click="handleRuleClick">
    <span>{{ langData.taskRuleBtn }}</span>
  </div>
</template>

<script setup>
import LanguageHook from "@/hooks/language";

// Props & Emits
const emit = defineEmits([
  "showRulePopup",
  "jumpToFacebook",
  "jumpToDiscord",
]);

const { langData } = LanguageHook();

// 方法
const handleRuleClick = () => {
  emit("showRulePopup");
};

const handleFacebookClick = () => {
  emit("jumpToFacebook");
};

const handleDiscordClick = () => {
  emit("jumpToDiscord");
};
</script>
